import TrackingConsent from './TrackingConsent';
import { COOKIES_ACCEPTED, MARKETING_ACCEPTED, ConsentCategory } from './constants';

/**
 * Reads consent state from URL search params, sets cookies, and strips the params from the URL.
 * Used on login page to receive consent propagated from landing pages (cross-subdomain).
 */
function hydrateConsentFromUrl(): boolean {
  if (typeof window === 'undefined') return false;

  const params = new URLSearchParams(window.location.search);
  const hasFunctional = params.get(COOKIES_ACCEPTED) === 'true';
  const hasMarketing = params.get(MARKETING_ACCEPTED) === 'true';

  if (!hasFunctional && !hasMarketing) return false;

  const categories: ConsentCategory[] = [];

  if (hasFunctional) {
    categories.push(ConsentCategory.Functional);
  }
  if (hasMarketing) {
    categories.push(ConsentCategory.Marketing);
  }

  TrackingConsent.getInstance().grantConsent(categories);

  params.delete(COOKIES_ACCEPTED);
  params.delete(MARKETING_ACCEPTED);

  const cleanSearch = params.toString();
  const newUrl = `${ window.location.pathname }${ cleanSearch ? `?${ cleanSearch }` : '' }${ window.location.hash }`;
  window.history.replaceState(window.history.state, '', newUrl);

  return true;
}

export default hydrateConsentFromUrl;
